import React from "react";
import { Container } from 'semantic-ui-react'
import { withRouter } from "react-router-dom";

function HomePageLayout() {
    return (
        <div>
            {/* Hero Section with Parallax */}
            <section className="hero-section-mega">
                <div className="mesh-gradient"></div>
                <div className="floating-shapes">
                    <div className="shape shape-1"></div>
                    <div className="shape shape-2"></div>
                    <div className="shape shape-3"></div>
                </div>
                <Container>
                    <div className="hero-content-mega">
                        
                        <h1 className="hero-title-mega">
                            Building products<br />
                            <span className="gradient-text">that scale</span>
                        </h1>
                        <p className="hero-subtitle-mega">
                            Crafting enterprise platforms and consumer applications
                            that solve real problems
                        </p>
                        <div className="hero-cta">
                            <a href="#products" className="btn-primary">Explore Products</a>
                            <a href="/contact" className="btn-secondary">Get in Touch</a>
                        </div>
                    </div>
                </Container>
                <div className="scroll-indicator">
                    <span>Scroll to explore</span>
                    <div className="scroll-arrow"></div>
                </div>
            </section>


            {/* Products Section - Enhanced */}
            <section className="products-section-mega" id="products">
                <Container>
                    <div className="section-header">
                        <h2 className="section-title">Our Products</h2>
                        <p className="section-subtitle">
                            Production-ready platforms serving thousands of users
                        </p>
                    </div>

                    {/* PokeSwift - Full Width Feature */}
                    <div className="product-feature product-feature-left">
                        <div className="product-feature-content">
                            <div className="product-tag orange">Vendor Platform</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
                                <img src="/images/pokeswift-icon.png" alt="PokeSwift" style={{ marginTop:"20px", width: '64px', height: '64px', objectFit: 'contain', flexShrink: 0 }} />
                                <h3 className="product-feature-title" style={{ marginBottom: 0 }}>
                                    PokeSwift
                                </h3>
                            </div>
                            <p className="product-feature-description">
                                Lightning-fast checkout for Pokémon vendors. Stop juggling calculators and
                                multiple comp sites. PokeSwift delivers instant pricing, AI-powered card recognition,
                                and seamless checkout—so you can keep the line moving at trade shows and never lose
                                a sale to a slow line.
                            </p>
                            <ul className="product-features-list">
                                <li>Comp faster with instant pricing</li>
                                <li>AI-powered card recognition</li>
                                <li>Price smarter with real-time market data</li>
                                <li>Close every sale quicker at shows</li>
                            </ul>
                            <div className="app-store-buttons" aria-label="Download PokeSwift">
                                <a
                                    href="https://apps.apple.com/us/app/pokeswift/id6759176184"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="app-store-button"
                                >
                                    <img
                                        src="/images/ios-download.png.webp"
                                        alt="Download PokeSwift on the App Store"
                                        loading="lazy"
                                    />
                                </a>
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.pokeswift.app"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="app-store-button"
                                >
                                    <img
                                        src="/images/android-download.png.webp"
                                        alt="Get PokeSwift on Google Play"
                                        loading="lazy"
                                    />
                                </a>
                            </div>
                            <a
                                href="https://pokeswift.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="product-link-mega"
                            >
                                Explore PokeSwift
                                <span className="arrow">→</span>
                            </a>
                        </div>
                        <div className="product-feature-visual">
                            <div className="visual-placeholder pokeswift-visual">
                                <div className="visual-glow"></div>
                                <img
                                    src="/images/apps/pokeswift-hero.png"
                                    alt="PokeSwift"
                                    loading="lazy"
                                    style={{
                                        width: '100%',
                                        borderRadius: '12px',
                                        boxShadow: '0 20px 60px rgba(0, 217, 255, 0.3)'
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* SocialBellow - Full Width Feature */}
                    <div className="product-feature product-feature-right">
                        <div className="product-feature-visual">
                            <div className="visual-placeholder socialbellow-visual">
                                <img
                                    src="https://www.socialbellow.com/images/socialbellow-logo.png"
                                    alt="SocialBellow"
                                    loading="lazy"
                                    style={{
                                        width: '280px',
                                        borderRadius: '24px'
                                    }}
                                />

                            </div>
                        </div>
                        <div className="product-feature-content">
                            <div className="product-tag orange">AI Platform</div>
                            <h3 className="product-feature-title">
                                Social Bellow                                
                            </h3>
                            <p className="product-feature-description">
                                AI-powered general-purpose chatbot platform for creative professionals.
                                Create and manage custom prompts, generate stunning AI images, and streamline
                                your creative workflow with intelligent automation.
                            </p>
                            <ul className="product-features-list">
                                <li>Custom prompt management</li>
                                <li>AI image generation</li>
                                <li>Multi-platform integration</li>
                                <li>Workflow automation</li>
                            </ul>
                            <div className="platform-integrations">
                                <a
                                    href="https://www.canva.com/your-apps/AAFjMZ7f2uQ/social-bellow"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="integration-badge canva"
                                >
                                    <img
                                        src="https://www.socialbellow.com/images/canva-circle-logo.png"
                                        alt="Canva"
                                        loading="lazy"
                                        className="integration-logo"
                                    />
                                    <div>
                                        <span>Available on</span>
                                        <strong>Canva</strong>
                                    </div>
                                </a>
                                <a
                                    href="https://new.express.adobe.com/new?category=addOns&launchAddOnId=wh35k4i3l"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="integration-badge adobe"
                                    style={{backgroundColor:"cornflowerblue"}}
                                >
                                    <img
                                        src="https://www.socialbellow.com/images/adobe_express_lockup_horizontal.png"
                                        alt="Adobe Express"
                                        loading="lazy"
                                        className="integration-logo adobe-logo"
                                    />
                                </a>
                            </div>
                            <a
                                href="https://socialbellow.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="product-link-mega"
                            >
                                Explore SocialBellow
                                <span className="arrow">→</span>
                            </a>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Technology Stack Section */}
            <section className="tech-stack-section">
                <Container>
                    <div className="section-header">
                        <h2 className="section-title">Built with Modern Technology</h2>
                        <p className="section-subtitle">
                            Production-grade stack for scalable, secure applications
                        </p>
                    </div>
                    <div className="tech-grid">
                        <div className="tech-category">
                            <h4 className="tech-category-title">Frontend</h4>
                            <div className="tech-items">
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                                        <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
                                    </svg>
                                    <span>React</span>
                                </div>
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                                    </svg>
                                    <span>Next.js</span>
                                </div>
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="16 18 22 12 16 6"></polyline>
                                        <polyline points="8 6 2 12 8 18"></polyline>
                                    </svg>
                                    <span>TypeScript</span>
                                </div>
                            </div>
                        </div>
                        <div className="tech-category">
                            <h4 className="tech-category-title">Backend</h4>
                            <div className="tech-items">
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <line x1="2" y1="12" x2="22" y2="12"></line>
                                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                    <span>Node.js</span>
                                </div>
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="3"></circle>
                                        <path d="M12 1v6m0 6v6"></path>
                                        <path d="M17 12h6M1 12h6"></path>
                                    </svg>
                                    <span>GraphQL</span>
                                </div>
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                                    </svg>
                                    <span>REST APIs</span>
                                </div>
                            </div>
                        </div>
                        <div className="tech-category">
                            <h4 className="tech-category-title">Cloud & DevOps</h4>
                            <div className="tech-items">
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
                                    </svg>
                                    <span>AWS</span>
                                </div>
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                                        <polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline>
                                        <polyline points="7.5 19.79 7.5 14.6 3 12"></polyline>
                                        <polyline points="21 12 16.5 14.6 16.5 19.79"></polyline>
                                        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                        <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                    </svg>
                                    <span>Serverless</span>
                                </div>
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <polyline points="12 6 12 12 16 14"></polyline>
                                    </svg>
                                    <span>CI/CD</span>
                                </div>
                            </div>
                        </div>
                        <div className="tech-category">
                            <h4 className="tech-category-title">AI & Data</h4>
                            <div className="tech-items">
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                                        <path d="M2 17l10 5 10-5"></path>
                                        <path d="M2 12l10 5 10-5"></path>
                                    </svg>
                                    <span>LLM Workflows</span>
                                </div>
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                    </svg>
                                    <span>AI Agents</span>
                                </div>
                                <div className="tech-item">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <line x1="18" y1="20" x2="18" y2="10"></line>
                                        <line x1="12" y1="20" x2="12" y2="4"></line>
                                        <line x1="6" y1="20" x2="6" y2="14"></line>
                                    </svg>
                                    <span>Analytics</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Capabilities Section - Redesigned */}
            <section className="capabilities-section-mega">
                <Container>
                    <div className="section-header">
                        <h2 className="section-title">What We Do</h2>
                        <p className="section-subtitle">
                            End-to-end development services
                        </p>
                    </div>
                    <div className="capabilities-grid-mega">
                        <div className="capability-card">
                            <div className="capability-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="16 18 22 12 16 6"></polyline>
                                    <polyline points="8 6 2 12 8 18"></polyline>
                                </svg>
                            </div>
                            <h3 className="capability-title">Full-Stack Development</h3>
                            <p className="capability-text">
                                Modern web and mobile applications built with React, Next.js, Node.js,
                                and AWS infrastructure. From concept to deployment.
                            </p>
                        </div>
                        <div className="capability-card">
                            <div className="capability-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                    <line x1="12" y1="11" x2="12" y2="11.01"></line>
                                    <line x1="12" y1="15" x2="12" y2="15.01"></line>
                                </svg>
                            </div>
                            <h3 className="capability-title">Financial & Inventory Systems</h3>
                            <p className="capability-text">
                                Transaction-heavy applications with real-time pricing, database-driven inventory
                                management, and financial tracking—from custom vendor tools to marketplace integrations.
                            </p>
                        </div>
                        <div className="capability-card">
                            <div className="capability-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                                    <path d="M2 17l10 5 10-5"></path>
                                    <path d="M2 12l10 5 10-5"></path>
                                </svg>
                            </div>
                            <h3 className="capability-title">AI Integration</h3>
                            <p className="capability-text">
                                Leverage cutting-edge AI models for content generation, automation,
                                and intelligent user experiences.
                            </p>
                        </div>
                        <div className="capability-card">
                            <div className="capability-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="3"></circle>
                                    <path d="M12 1v6m0 6v6"></path>
                                    <path d="M17 12h6M1 12h6"></path>
                                    <path d="M17 17l4 4M3 3l4 4m10 0l4-4M3 21l4-4"></path>
                                </svg>
                            </div>
                            <h3 className="capability-title">API Development</h3>
                            <p className="capability-text">
                                RESTful and GraphQL APIs with comprehensive documentation,
                                authentication, and rate limiting.
                            </p>
                        </div>
                        <div className="capability-card">
                            <div className="capability-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
                                </svg>
                            </div>
                            <h3 className="capability-title">Cloud Architecture</h3>
                            <p className="capability-text">
                                Scalable, secure infrastructure on AWS with automated deployments
                                and monitoring.
                            </p>
                        </div>
                        <div className="capability-card">
                            <div className="capability-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="20" x2="18" y2="10"></line>
                                    <line x1="12" y1="20" x2="12" y2="4"></line>
                                    <line x1="6" y1="20" x2="6" y2="14"></line>
                                </svg>
                            </div>
                            <h3 className="capability-title">Data & Analytics</h3>
                            <p className="capability-text">
                                Real-time analytics dashboards, data pipelines, and business
                                intelligence solutions.
                            </p>
                        </div>
                    </div>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <Container>
                    <div className="cta-content">
                        <h2 className="cta-title">Ready to build something great?</h2>
                        <p className="cta-subtitle">
                            Let's discuss your project and explore how we can help bring your vision to life
                        </p>
                        <a href="/contact" className="btn-cta">Start a Conversation</a>
                    </div>
                </Container>
            </section>
        </div>
    )
}

export default withRouter(HomePageLayout)
